export default __webpack_public_path__ + "static/media/4000.8e3c166d.jpg";